import styled from 'styled-components';

import { mediaUp, rem } from 'approot/shared/style';
import {
  marginCss,
  MarginProps,
  spacing16,
  spacing24,
} from 'approot/shared/styles/spacing.style';
import { grey1 } from 'approot/shared/styles/colours.style';

export const ClassroomAnswerDetailHeaderPicker = styled.div`
  background-color: ${grey1};
  position: sticky;
  top: 0;
  padding: ${rem(spacing24)} 0;
  // sits above interactive sequence response components
  z-index: 101;
`;

export const ClassroomAnswerDetailHeaderButtons = styled.div<MarginProps>`
  ${marginCss}

  display: flex;
  flex-direction: column;
  align-items: flex-start;
  max-width: ${rem(210)};
  gap: ${rem(spacing16)};

  ${mediaUp.sm`
    max-width: 100%;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
  `}
`;
